<template>
  <b-overlay
    :show="isLoadingProduto || isLoading"
    rounded="sm"
  >
    <div class="position-absolute" style="top: -50px;right: 0">
      <b-button variant="outline-primary" class="mr-2" :to="{name: 'apps-produtos-list'}">Cancelar</b-button>
      <b-button
          variant="primary"
          @click="handleSubmit"
      >
        {{ isEditarForm ? 'Editar' : 'Salvar' }}
      </b-button>
    </div>
    <validation-observer ref="refFormEditProduto">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12">
            <b-card class="mobile-inputs-stack">
              <b-card-title class="bg-gray">
                <span>Edição do produto</span>
              </b-card-title>
              <b-row>
                <b-col cols="3">
                  <b-form-group label="ID*">
                    <validation-provider
                        #default="{ errors }"
                        name="ID do Produto"
                        rules="required|numeric"
                    >
                      <b-form-input
                          placeholder="ID do produto"
                          :state="errors.length > 0 ? false:null"
                          v-model="formProduto.item_id"
                          disabled
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="6">
                  <b-form-group label="Descrição*">
                    <validation-provider
                        #default="{ errors }"
                        name="Descrição"
                        rules="required"
                    >
                      <b-form-input
                          v-model="formProduto.item_descricao"
                          :state="errors.length > 0 ? false:null"
                          placeholder="Descrição"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Unidade de medida*">
                    <validation-provider
                        #default="{ errors }"
                        name="Unidade de medida"
                        rules="required"
                    >
                      <v-select
                          v-model="formProduto.unidade_medida_id"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="dataFromApiUnidadeMedida"
                          :loading="isLoadingUnidadeMedida"
                          label="unidade_medida_descricao"
                          :reduce="item => item.unidade_medida_id"
                          key="unidade_medida_id"
                          :state="errors.length > 0 ? false:null"
                          :clearable="false"
                          placeholder="Selecione"
                          input-id="id_unidade_medida"
                          required
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="mt-1">
                <b-col cols="3">
                  <b-form-group label="Peso Bruto*">
                    <validation-provider
                        #default="{ errors }"
                        name="Peso Bruto"
                        rules="required|decimal"
                    >
                      <b-form-input
                          placeholder="Peso Bruto"
                          :state="errors.length > 0 ? false:null"
                          v-model="formProduto.item_peso_bruto"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Peso Líquido*">
                    <validation-provider
                        #default="{ errors }"
                        name="Peso Líquido"
                        rules="required|decimal"
                    >
                      <b-form-input
                          v-model="formProduto.item_peso_liquido"
                          :state="errors.length > 0 ? false:null"
                          placeholder="Peso Líquido"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Comprimento do produto">
                    <validation-provider
                        #default="{ errors }"
                        name="Comprimento do produto"
                        rules="decimal"
                    >
                  <b-form-input
                      v-model="formProduto.item_comprimento"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Comprimento do produto"
                      :disabled="isEditarForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Código de origem">
                    <validation-provider
                        #default="{ errors }"
                        name="Código de origem"
                        rules="numeric"
                    >
                  <b-form-input
                      v-model="formProduto.item_codigo_origem"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Código de origem"
                      :disabled="isEditarForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="mt-1">
                <b-col cols="3">
                  <b-form-group label="Família comercial*">
                    <validation-provider
                        #default="{ errors }"
                        name="Família comercial"
                        rules="required"
                    >
                      <v-select
                        v-model="formProduto.familia_comercial_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="dataFromApiFamiliaComercial"
                        :loading="isLoadingFamiliaComercial"
                        label="familia_comercial_descricao"
                        :reduce="item => item.familia_comercial_id"
                        key="familia_comercial_id"
                        :state="errors.length > 0 ? false:null"
                        :clearable="false"
                        placeholder="Selecione"
                        input-id="id_familia_comercial"
                        required
                        :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Família material*">
                    <validation-provider
                        #default="{ errors }"
                        name="Família material"
                        rules="required"
                    >
                      <v-select
                        v-model="formProduto.familia_material_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="dataFromApiFamiliaMaterial"
                        :loading="isLoadingFamiliaMaterial"
                        label="familia_material_descricao"
                        :reduce="item => item.familia_material_id"
                        key="familia_material_id"
                        :state="errors.length > 0 ? false:null"
                        :clearable="false"
                        placeholder="Selecione"
                        input-id="id_familia_material"
                        required
                        :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Grupo estoque*">
                    <validation-provider
                        #default="{ errors }"
                        name="Grupo estoque"
                        rules="required"
                    >
                      <v-select
                        v-model="formProduto.grupo_estoque_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="dataFromApiGrupoEstoque"
                        :loading="isLoadingGrupoEstoque"
                        label="grupo_estoque_descricao"
                        :reduce="item => item.grupo_estoque_id"
                        key="grupo_estoque_id"
                        :state="errors.length > 0 ? false:null"
                        :clearable="false"
                        placeholder="Selecione"
                        input-id="id_grupo_estoque"
                        required
                        :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Classificação fiscal*">
                    <validation-provider
                        #default="{ errors }"
                        name="Classificação fiscal"
                        rules="required"
                    >
                      <v-select
                        v-model="formProduto.classificacao_fiscal_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="dataFromApiClassificacaoFiscal"
                        :loading="isLoadingClassificacaoFiscal"
                        label="classificacao_fiscal_descricao"
                        :reduce="item => item.classificacao_fiscal_id"
                        key="classificacao_fiscal_id"
                        :state="errors.length > 0 ? false:null"
                        :clearable="false"
                        placeholder="Selecione"
                        input-id="id_classificacao_fiscal"
                        required
                        :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="mt-1">
                <b-col cols="4">
                  <b-form-group label="Código da cor*">
                    <b-input-group>
                      <b-form-input placeholder="Digite o código da cor..." v-model="formProduto.cdn_cor" :disabled="isEditarForm"/>
                      <b-input-group-append>
                        <b-button variant="outline-primary" @click="searchCor()" v-b-tooltip.hover.top="'Definir cor'" :disabled="isEditarForm">
                          <feather-icon icon="CheckIcon" />
                        </b-button>
                      </b-input-group-append>
                      <b-input-group-append>
                        <b-button variant="outline-primary" @click="showCollapse = !showCollapse" v-b-tooltip.hover.top="'Procurar cores'" :disabled="isEditarForm">
                          <feather-icon icon="SearchIcon" />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="2" align-self="end">
                  <b-form-group label-for="readOnlyInput" label="Descrição da cor">
                    <b-form-input id="readOnlyInput" v-model="nameColor"
                      :state="nameColor === 'Cor não encontrada' ? false : null" :style="{
                        color: nameColor === 'Cor não encontrada' ? 'red' : 'black',
                      }" readonly />
                  </b-form-group>
                </b-col>

                <b-col cols="12" v-if="showCollapse">
                  <app-collapse accordion>
                    <app-collapse-item title="Lista de Cores" is-visible class-header-collapse="bg-gray">
                      <b-row>
                        <b-col cols="12">
                          <b-form-group label="Pesquisar">
                            <b-input-group>
                              <b-form-input placeholder="Digite o código da cor..." v-model="searchColor"
                                @input="listarCores()" />
                                <b-input-group-append>
                                  <b-button variant="outline-danger" @click="searchColor = ''" v-b-tooltip.hover.top="'Limpar filto'">
                                    <feather-icon icon="TrashIcon" />
                                  </b-button>
                                </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12">
                          <div v-if="!searchColor || searchColor.trim() === ''" class="text-center my-4">
                            <feather-icon icon="InfoIcon" size="24" class="text-muted mb-1"></feather-icon>
                            <h6 class="text-muted">Digite o código ou descrição da cor para pesquisar</h6>
                          </div>

                          <div v-else>
                            <b-table :busy="colorLoading" :striped="true" :bordered="true" :hover="true"
                              :responsive="true" ref="refTableColor" table-variant="secondary"
                              :per-page="paginationColor.perPage" :current-page="paginationColor.page"
                              :fields="fieldColos" :items="filterDataColor" responsive="sm" show-empty empty-text="Nenhuma cor encontrada">
                              <template #table-busy>
                                <div class="text-center my-2">
                                  <b-spinner class="align-middle mr-1"></b-spinner>
                                  <strong>Carregando...</strong>
                                </div>
                              </template>
                              <template #cell(index)="data">
                                {{ data.index + 1 }}
                              </template>

                              <template #cell(acoes)="data">
                                <b-button variant="primary" size="sm" @click="onSelectColor(data.item)">
                                  Selecionar
                                </b-button>
                              </template>
                            </b-table>
                          </div>
                        </b-col>
                      </b-row>
                    </app-collapse-item>
                  </app-collapse>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Embalagem*">
                    <validation-provider #default="{ errors }" name="Embalagem" rules="required">
                      <v-select v-model="formProduto.cdn_embalagem" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="dataFromApiEmbalagens" :loading="isLoadingEmbalagens" label="des_embalag"
                        :reduce="item => item.cdn_embalag" key="cdn_embalag" :state="errors.length > 0 ? false : null"
                        :clearable="false" placeholder="Selecione" input-id="id_embalagem" required
                        :disabled="isEditarForm" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Tamanho*">
                    <validation-provider #default="{ errors }" name="Tamanho" rules="required">
                      <v-select v-model="formProduto.cdn_tamanho" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="dataFromApiTamanho" :loading="isLoadingTamanho" label="des_tamanho"
                        :reduce="item => item.cdn_tamanho" key="cdn_tamanho" :state="errors.length > 0 ? false : null"
                        :clearable="false" placeholder="Selecione" input-id="id_tamanho" required
                        :disabled="isEditarForm" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="mt-1">
                <b-col cols="3">
                  <b-form-group label="Categoria*">
                    <validation-provider
                        #default="{ errors }"
                        name="Categoria"
                        rules="required"
                    >
                      <v-select
                        v-model="formProduto.cod_categ"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="dataFromApiCategoria"
                        :loading="isLoadingCategoria"
                        label="descricao"
                        :reduce="item => item.cod_categ"
                        key="cod_categ"
                        :state="errors.length > 0 ? false:null"
                        :clearable="false"
                        placeholder="Selecione"
                        input-id="id_categoria"
                        required
                        :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Código tributação*">
                    <validation-provider
                        #default="{ errors }"
                        name="Código tributação"
                        rules="required"
                    >
                      <v-select
                        v-model="formProduto.item_cod_tributacao_icms"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="codigoTributacao"
                        :state="errors.length > 0 ? false:null"
                        placeholder="Selecione"
                        required
                        :clearable="false"
                        :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Largura*">
                    <validation-provider
                        #default="{ errors }"
                        name="Largura"
                        rules="required|decimal"
                    >
                      <b-form-input
                        v-model="formProduto.item_largura"
                        :state="errors.length > 0 ? false:null"
                        placeholder="Largura"
                        :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-form-group label="Gramatura*">
                    <validation-provider
                        #default="{ errors }"
                        name="Gramatura"
                        rules="required|decimal"
                    >
                    <b-form-input
                        v-model="formProduto.item_gramatura"
                        :state="errors.length > 0 ? false:null"
                        placeholder="Gramatura"
                        :disabled="isEditarForm"
                    />
                      <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="mt-1">
                <b-col cols="2">
                  <b-form-group label="Situação*">
                    <validation-provider
                        #default="{ errors }"
                        name="Situação"
                        rules="required"
                    >
                      <v-select
                        v-model="formProduto.item_situacao"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="situacao"
                        :state="errors.length > 0 ? false:null"
                        placeholder="Selecione"
                        required
                        :clearable="false"
                        :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="4">
                  <b-form-group label="Inf. complementar">
                    <validation-provider
                        #default="{ errors }"
                        name="Inf. complementar"
                    >
                  <b-form-input
                      v-model="formProduto.item_inf_complementar"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Inf. complementar"
                      :disabled="isEditarForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="2">
                  <b-form-group label="Aliquota IPI*">
                    <validation-provider
                        #default="{ errors }"
                        name="Aliquota IPI"
                        rules="required|decimal"
                    >
                      <b-form-input
                          placeholder="Aliquota IPI"
                          :state="errors.length > 0 ? false:null"
                          v-model="formProduto.item_aliquota_ipi"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="2">
                  <b-form-group label="Lote múltiplo*">
                    <validation-provider
                        #default="{ errors }"
                        name="Lote múltiplo"
                        rules="required|decimal"
                    >
                      <b-form-input
                          placeholder="Lote múltiplo"
                          :state="errors.length > 0 ? false:null"
                          v-model="formProduto.item_lote_multiplo"
                          :disabled="isEditarForm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="2">
                  <b-form-group label="Disponível B2B">
                    <b-form-checkbox
                      v-model="formProduto.log_dispon_b2b"
                      :value="1"
                      :unchecked-value="0"
                      :disabled="isEditarForm"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import {
  required, regex, numeric,
} from '@core/utils/validations/validations';
import SlsCorService from '@/services/SistemaDKP/sls-cor.service';
import axios from '@/libs/axios';
import { extend } from 'vee-validate';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import SLSItemService from '@/services/SistemaDKP/SLSItem.service';

const slsCorService = new SlsCorService();
const slsItemService = new SLSItemService();

extend('decimal', {
  validate(value) {
    const regex = /^-?\d+([\.,]\d+)?$/;
    return regex.test(value);
  },
  message: 'O campo deve ser decimal!',
});

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
  },
  data() {
    return {
      isLoadingProduto: true,
      isLoading: false,
      formProduto: [],
      isEditarForm: true,
      dataFromApiUnidadeMedida: [],
      isLoadingUnidadeMedida: false,
      dataFromApiFamiliaComercial: [],
      isLoadingFamiliaComercial: false,
      dataFromApiFamiliaMaterial: [],
      isLoadingFamiliaMaterial: false,
      dataFromApiGrupoEstoque: [],
      isLoadingGrupoEstoque: false,
      dataFromApiClassificacaoFiscal: [],
      isLoadingClassificacaoFiscal: false,
      dataFromApiEmbalagens: [],
      isLoadingEmbalagens: false,
      dataFromApiTamanho: [],
      isLoadingTamanho: false,
      dataFromApiCategoria: [],
      isLoadingCategoria: false,
      codigoTributacao: ['Reduzido', 'Tributado'],
      situacao: ['ATIVO', 'INATIVO'],
      colorLoading: false,
      showCollapse: false,
      searchColor: '',
      fieldColos: [
        { key: 'cdn_cor', label: 'Código da cor' },
        { key: 'des_cor', label: 'Descrição da cor' },
        { key: 'acoes', label: 'Ações' },
      ],
      nameColor: null,
      dataColors: [],
      required,
      regex,
      numeric,
    };
  },
  computed: {
    filterDataColor() {
      return this.dataColors;
    },
    paginationColor: {
      get() {
        return this.$store.getters['slsCor/getFilters'];
      },
      set(val) {
        this.$store.commit('slsCor/setFilters', val);
      },
    },
  },
  methods: {
    async fetchProduto() {
      try {
        const productId = this.$route.params.id;
        const response = await axios.get(`/items/${productId}`);
        this.formProduto = response.data;
      } catch (error) {
        console.error('Erro ao chamar a API para Produto: ', error);
      } finally {
        this.isLoadingProduto = false;
      }
    },
    async fetchDataFromUnidadeMedida() {
      this.isLoadingUnidadeMedida = true;
      try {
        const response = await axios.get('/unidade-medida?perPage=100');
        this.dataFromApiUnidadeMedida = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API para Unidade Medida: ', error);
      } finally {
        this.isLoadingUnidadeMedida = false;
      }
    },
    async fetchDataFromFamiliaComercial() {
      this.isLoadingFamiliaComercial = true;
      try {
        const response = await axios.get('/familia-comercial?perPage=10000');
        this.dataFromApiFamiliaComercial = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API para Familia Comercial: ', error);
      } finally {
        this.isLoadingFamiliaComercial = false;
      }
    },
    async fetchDataFromFamiliaMaterial() {
      this.isLoadingFamiliaMaterial = true;
      try {
        const response = await axios.get('/familia-material?perPage=10000');
        this.dataFromApiFamiliaMaterial = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API para Familia Material: ', error);
      } finally {
        this.isLoadingFamiliaMaterial = false;
      }
    },
    async fetchDataFromGrupoEstoque() {
      this.isLoadingGrupoEstoque = true;
      try {
        const response = await axios.get('/grupo-estoque?perPage=100');
        this.dataFromApiGrupoEstoque = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API para Grupo Estoque: ', error);
      } finally {
        this.isLoadingGrupoEstoque = false;
      }
    },
    async fetchDataFromClassificacaoFiscal() {
      this.isLoadingClassificacaoFiscal = true;
      try {
        const response = await axios.get('/classificacao-fiscal?perPage=10000');
        this.dataFromApiClassificacaoFiscal = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API para Classificação Fiscal: ', error);
      } finally {
        this.isLoadingClassificacaoFiscal = false;
      }
    },
    async fetchDataFromEmbalagens() {
      this.isLoadingEmbalagens = true;
      try {
        const response = await axios.get('/embalagens?perPage=10000');
        this.dataFromApiEmbalagens = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API para Embalagem: ', error);
      } finally {
        this.isLoadingEmbalagens = false;
      }
    },
    async fetchDataFromTamanho() {
      this.isLoadingTamanho = true;
      try {
        const response = await axios.get('/tamanhos?perPage=10000');
        this.dataFromApiTamanho = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API para Tamanho: ', error);
      } finally {
        this.isLoadingTamanho = false;
      }
    },
    async fetchDataFromCategoria() {
      this.isLoadingCategoria = true;
      try {
        const response = await axios.get('/categorias?perPage=10000');
        this.dataFromApiCategoria = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API para Categoria: ', error);
      } finally {
        this.isLoadingCategoria = false;
      }
    },
    async searchCor() {
      await slsCorService.index({ cdn_cor: this.formProduto.cdn_cor }).then((response) => {
        if (response.length === 0) return this.nameColor = 'Cor não encontrada';
        this.nameColor = response[0].des_cor;
      });
    },
    onSelectColor(cor) {
      this.formProduto.cdn_cor = cor.cdn_cor;
      this.nameColor = cor.des_cor;
      this.showCollapse = false;
    },
    async listarCores(pagination) {
      if (!this.searchColor || this.searchColor.trim() === '') {
        this.dataColors = [];
        this.colorLoading = false;
        return;
      }

      this.colorLoading = true;
      try {
        const response = await slsCorService.index({
          q: this.searchColor,
          ...pagination,
        });
        this.dataColors = response;
      } catch (error) {
        console.error('Erro ao listar cores:', error);
      } finally {
        this.colorLoading = false;
      }
    },
    async handleSubmit() {
      if (this.isEditarForm) {
        this.isEditarForm = false;
        return;
      }

      const isValid = await this.$refs.refFormEditProduto.validate();

      // if (!isValid) {
      //   this.isLoading = false
      // }

      if (isValid) {
        try {
          this.isLoading = true;
          await slsItemService.updateItem(this.$route.params.id, this.formProduto);
          await this.$refs.refFormEditProduto.reset();
          await this.$router.push({ name: 'apps-produtos-list' });

          this.isLoading = false;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso!',
              text: 'Produto alterado com sucesso.',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });
        } catch (error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao alterar Produto!',
              text: error.message,
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.isLoading = false;
        } finally {
          this.isLoading = false;
        }
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro!',
            text: 'Por favor, corrija os erros no formulário antes de continuar.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
      }
    },
  },
  async mounted() {
    await this.listarCores();
    this.fetchDataFromUnidadeMedida();
    this.fetchDataFromFamiliaComercial();
    this.fetchDataFromFamiliaMaterial();
    this.fetchDataFromGrupoEstoque();
    this.fetchDataFromClassificacaoFiscal();
    this.fetchDataFromEmbalagens();
    this.fetchDataFromTamanho();
    this.fetchDataFromCategoria();
    this.fetchProduto();

    setTimeout(() => {
      this.searchCor();
    }, 1000);
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@media (max-width: 767.98px) {
  .mobile-inputs-stack .row > [class^="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 0.75rem;
  }

  .mobile-inputs-stack .row > [class^="col-"]:last-child {
    margin-bottom: 0;
  }

  .mobile-inputs-stack .input-group,
  .mobile-inputs-stack .b-form-group,
  .mobile-inputs-stack .form-group,
  .mobile-inputs-stack .vs__dropdown-toggle,
  .mobile-inputs-stack .form-control {
    width: 100% !important;
  }
}
</style>
